module.exports = __webpack_public_path__ + "fonts/RenaultLife-LightItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-LightItalic.eot
// module id = 363
// module chunks = 0